import { render, staticRenderFns } from "./DistributorTree.vue?vue&type=template&id=54c7abfb"
import script from "./DistributorTree.vue?vue&type=script&lang=js"
export * from "./DistributorTree.vue?vue&type=script&lang=js"
import style0 from "./DistributorTree.vue?vue&type=style&index=0&id=54c7abfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports